// 1. Import required libraries and components
import React from 'react';
import { makeStyles, } from "@mui/styles"
import { AppBar, Toolbar, Typography, Box, Paper } from '@fedsim/components';
import Parallax from '../components/parallax';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useBrands } from 'contexts/Brand';

// 2. Define useStyles function
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    backgroundColor: "#3f51b5",
  },
  toolbar: {
    minHeight: 128,
    alignItems: "flex-start",
  },
  title: {
    flexGrow: 1,
    alignSelf: "flex-end",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  parallax: {
    minHeight: 400,
    // background: "url('/images/parallax-bg.jpg') center / cover",
  },
}));

// 3. Create header component
const Header = () => {
  const classes = useStyles();

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Typography variant="h4" className={classes.title}>
          Fed Sim X
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

// 4. Create features component
const Features = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>Feature 1</Paper>
  );
};

// 5. Create showcase component
const Showcase = () => {
  const classes = useStyles();

  return (
    <Parallax className={classes.parallax}>
      {/* Add content to showcase */}
    </Parallax>
  );
};

// 6. Create footer component
const Footer = () => {
  return (
    <Box mt={5}>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        Fedisimulator {new Date().getFullYear()}
        {'.'}
      </Typography>
    </Box>
  );
};

// 7. Assemble components in the main App component
export const App = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <Features />
      <Showcase />
      <Footer />
    </div>
  );
};

const Container = () => {
  const { imported: brands } = useBrands()
  const nav = useNavigate()

  useEffect(() => {
    if (brands?.length === 0) {
      nav('/setup/setup')
    } else {
      nav('/office')
    }
  }, [brands, nav])

  return null;
}


export default Container;
